import * as React from 'react'
import styled from 'styled-components'
import TextInput from '../TextInput/TextInput'
import media from '../../../services/generateMediaQueries'

export const SearchFieldContainer = styled.div`
  ${({ banner, left }) => banner && left && 'margin-right: 1rem;'}
  width: 50%;
  color: #fff;
  position: relative;

  ${media.lessThan('medium')`
    width:100%;
`}

  ${media.lessThan('small')`
    margin-right:initial;
`}
`
export const StyledSearchInput = styled(TextInput)`
  display: flex;

  color: ${({ dark }) => (dark ? '#4a4a4a' : '#fff')};

  &::placeholder {
    opacity: 1;
    color: ${({ dark }) => (dark ? '#4a4a4a87' : '#fff')} !important;
  }

  &:placeholder-shown ~ span {
    color: ${({ dark }) => (dark ? '#4a4a4a87' : '#fff')};
  }

  ${media.lessThan('medium')`
  flex: unset;
  width: 100%;
  margin-right: 0px;
  transition: all var(--animation-duration) var(--animation-easing);
  height: 3rem;
  margin-bottom: 1rem;

  &:hover {
    transition: all var(--animation-duration) var(--animation-easing);
  }
`}
`

export const SuggestionContainer = styled.div`
  background-color: var(--color-bg-light);
  color: var(--color-primary);
  margin-top: -2rem;
  // border-radius: 0 0 var(--border-radius-form) var(--border-radius-form);
  border-radius: var(--border-radius-form);
  position: absolute;
  width: 100%;
  z-index: 10;

  div {
    padding: 0.5rem 1rem;
  }

  .focusedSuggestion,
  div:hover {
    color: var(--color-bg-light);
    background-color: var(--color-primary);
  }

  div:not(:last-of-type) {
    border-bottom: 1px solid var(--color-fg-lighter);
  }
`

const InputWithSuggestion = ({
  showSuggestion,
  dataSource,
  handleSelectSuggestion,
  onEnter,
  styleProps,
  ...restOfProps
}) => {
  const [suggestionState, setSuggestionState] = React.useState(false)
  const [suggestedCurrentIndex, setSuggestedCurrentIndex] = React.useState(
    false,
  )

  React.useEffect(() => {
    setSuggestionState(showSuggestion)
  }, [showSuggestion])

  const onKeyDownSearch = e => {
    if (e.keyCode === 40 && suggestedCurrentIndex < dataSource.length - 1) {
      //down
      setSuggestedCurrentIndex(suggestedCurrentIndex + 1)
    } else if (e.keyCode === 38 && suggestedCurrentIndex > -1) {
      //up
      setSuggestedCurrentIndex(suggestedCurrentIndex - 1)
    } else if (e.keyCode === 13 && suggestedCurrentIndex > -1) {
      const selectedSuggestion = dataSource[suggestedCurrentIndex]
      e.preventDefault()
      setSuggestionState(false)
      setSuggestedCurrentIndex(-1)
      onEnter(
        selectedSuggestion, // selected
        selectedSuggestion.name, //query value
        [dataSource[suggestedCurrentIndex]], //new dataSource value
      )
    }
  }

  const { value } = restOfProps

  return (
    <SearchFieldContainer
      onBlur={e => {
        if (!e.currentTarget.contains(e.relatedTarget)) {
          setSuggestionState(false)
        }
      }}
      {...styleProps}
    >
      <StyledSearchInput
        onKeyDown={onKeyDownSearch}
        onClick={() => setSuggestionState(true)}
        data-testid="input"
        {...restOfProps}
      />
      {suggestionState && value && dataSource && dataSource.length !== 0 && (
        <SuggestionContainer tabIndex="0" data-testid="suggestion-box">
          {dataSource.map((store, index) => (
            <div
              className={
                Number(index) === Number(suggestedCurrentIndex)
                  ? 'focusedSuggestion'
                  : ''
              }
              key={store.id}
              onClick={() => {
                handleSelectSuggestion(store, index)
              }}
            >
              {store.name}
            </div>
          ))}
        </SuggestionContainer>
      )}
    </SearchFieldContainer>
  )
}
InputWithSuggestion.defaultProps = {
  styledProps: {},
}

//   InputWithSuggestion.propTypes = {
//     id: PropTypes.string.isRequired,
//     show: PropTypes.bool.isRequired,
//     handleClose: PropTypes.func.isRequired,
//     children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
//       .isRequired,
//     CloseButton: PropTypes.element,
//   }

export default InputWithSuggestion
